import { render, staticRenderFns } from "./AdmissionStatisticalReport.vue?vue&type=template&id=3b3ca0a8&scoped=true"
import script from "./AdmissionStatisticalReport.vue?vue&type=script&lang=js"
export * from "./AdmissionStatisticalReport.vue?vue&type=script&lang=js"
import style0 from "./AdmissionStatisticalReport.vue?vue&type=style&index=0&id=3b3ca0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ca0a8",
  null
  
)

export default component.exports